import React from 'react'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'

import Items from '../components/Items'
import Root from '../layouts/Root'
import config from '../config'

const Vacatures = ({ data }) => (
  <Root>
    {/* prettier-ignore */}
    <Helmet>
      <title>{`Vacatures | ${config.title}`}</title>
      <meta property="og:title" content={`Vacatures | ${config.title}`} />
      <meta name="description" content="Een overzicht van openstaande vacatures bij W&R beveiliging. Op zoek naar een leuke baan in de beveiligingsbranche? Bekijk onze vacatures." />
      <meta property="og:description" content="Een overzicht van openstaande vacatures bij W&R beveiliging. Op zoek naar een leuke baan in de beveiligingsbranche? Bekijk onze vacatures." />
    </Helmet>

    <main>
      <h1 className="t-heading-l t-center">Vacatures</h1>

      <div className="wrapper-s t-center" style={{ marginBottom: 40 }}>
        <p>
          Onderstaand een overzicht van openstaande vacatures bij W&R
          beveiliging. Ter uitbreiding van ons team zijn wij momenteel op zoek
          naar het volgende:
        </p>
      </div>

      <Items data={data.vacatures} maxTwo />
    </main>
  </Root>
)

export const query = graphql`
  query {
    vacatures: allMarkdownRemark(
      filter: { fields: { slug: { regex: "/^/vacatures/.+$/" } } }
      sort: { fields: [frontmatter___title], order: ASC }
    ) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            title
            cover_alt
            cover {
              childImageSharp {
                fluid(maxWidth: 600, maxHeight: 400, toFormat: JPG) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          fields {
            slug
          }
          excerpt
        }
      }
    }
  }
`

export default Vacatures
